import {Component, OnInit} from '@angular/core';
import {JwtDecoderService} from './framework/services/jwt-decoder.service';
import {NavigationEnd, Router, RouterEvent} from '@angular/router';
import {AuthGuardService} from './framework/services/auth-guard.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {NewsService} from './framework/services/news.service';
import {News} from './framework/domain/news';
import * as moment from 'moment';
import {ConfigService} from './framework/services/config.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public showInfo = false;
    public curApp: string;
    private currentUrl: string;
    public news: News;
    public newsIsActive = false;
    public logiLearnEnabled = false;

    constructor(private jwtHelper: JwtDecoderService, private router: Router,
                private authGuardService: AuthGuardService,
                private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer,
                private newsService: NewsService,
                private configService: ConfigService) {
        this.matIconRegistry.addSvgIcon('keine_auseinandersetzung', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconKeineAuseinandersetzung_200x200.svg'));
        this.matIconRegistry.addSvgIcon('keine_SB', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconKeineSB_200x200.svg'));
        this.matIconRegistry.addSvgIcon('keine_sicherheitsleistung', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconKeineSicherheitsleistung_200x200.svg'));
        this.matIconRegistry.addSvgIcon('keine_vergleichsangebote', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconKeineVergleichsangebote_200x200.svg'));
        this.matIconRegistry.addSvgIcon('keine_vorleistung', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconKeineVorleistung_200x200.svg'));
        this.matIconRegistry.addSvgIcon('klassengleiches_FZ', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconKlassengleichesFZ_200x200.svg'));
        this.matIconRegistry.addSvgIcon('vermittlung_zustellung', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconVermittlungZustellung_200x200.svg'));
        this.matIconRegistry.addSvgIcon('wunschort', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/iconWunschort_200x200.svg'));
        this.matIconRegistry.addSvgIcon('hinweis', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/svg/icon_hinweis_34x30.svg'));
    }

    ngOnInit() {
        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                this.showInfo = false;
                this.currentUrl = event.url;
                if (this.currentUrl.indexOf('miwap') > -1) {
                    this.curApp = 'miwap';
                } else if (this.currentUrl.indexOf('kobra') > -1) {
                    this.curApp = 'kobra';
                } else if (this.currentUrl.indexOf('horch') > -1) {
                    this.curApp = 'horch';
                } else if (this.currentUrl.indexOf('lip') > -1) {
                    this.curApp = 'lip';
                }
            }
        });
        this.newsService.newsLoaded.subscribe((res) => {
            this.news = res;
            const date2 = moment(this.news.activeTill).hours(23).minute(59);
            this.newsIsActive = moment().isBefore(date2);
        });
        this.configService.configLoaded.subscribe((res) => {
            if (res && res['enable_logi_learn'] && res['enable_logi_learn'][0].value === true) {
                this.logiLearnEnabled = true;
            }
        });
    }

    logout() {
        this.authGuardService.logout().then(() => {
                sessionStorage.removeItem('LOGICHECK.token');
                window.location.href = '/login';
            }
        );

    }

    isAuthenticated() {
        return sessionStorage.getItem('LOGICHECK.token');
    }

    hasRole(role: string) {
        if (!this.jwtHelper.getAuthToken()) {
            return false;
        }
        return this.jwtHelper.hasRole(role);
    }
}
